module.exports = __webpack_public_path__ + "img/Berry.11280505.svg";